"use client";

import { IPaymentMethodsIconProps } from "@faire/icons/types/IPaymentMethodsIconProps";
import React from "react";

import { CBRectangle } from "./CBRectangle";
import { CBSquare } from "./CBSquare";

export const CB = React.memo(
  ({
    borderless,
    square,
    monochrome,
    ref,
    ...iconProps
  }: IPaymentMethodsIconProps & React.RefAttributes<SVGElement>) => {
    const Icon = square ? CBSquare : CBRectangle;
    return <Icon ref={ref} {...iconProps} />;
  }
);
